module.exports = __webpack_public_path__ + "media/images/flags/ci-b9b286f92869adad1770ee35f4305f80.svg";